import React from "react"
import FuboBanner from "src/components/common/FuboBanner"
import { StyledSectionContainer } from "src/components/common/StyledSectionContainer"
import styled from "styled-components"

const ChannelsSection = () => {
  const list = [
    {
      name: "Fubo",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/icons/Fubo_Primary_Logo_Icon_FC_RGB.png?ch=width&auto=format,compress",
    },
    {
      name: "Hulu + Live TV",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/HuluLivetc.png?ch=width&auto=format,compress",
    },
    {
      name: "Roku Channel",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/roku.jpg?ch=width&auto=format,compress",
    },
    {
      name: "Samsung TV Plus",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/samsung.jpg?ch=width&auto=format,compress",
    },
    {
      name: "Tubi",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/tubi.jpg?ch=width&auto=format,compress",
    },
    {
      name: "Xumo Play",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/Xumo.png?ch=width&auto=format,compress",
    },
    {
      name: "Amazon Prime Video",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/icons/Amazon-Prime-Video-Icon-v2.png?ch=width&auto=format,compress",
    },
    {
      name: "Plex",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/plex.jpg?ch=width&auto=format,compress",
    },
    {
      name: "LG Channels",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/lg.jpg?ch=width&auto=format,compress",
    },
    {
      name: "Vizio Watch Free+",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/vizio.jpg?ch=width&auto=format,compress",
    },
    {
      name: "TCL",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/icons/TCL.jpg?ch=width&auto=format,compress",
    },
    {
      name: "Tablo TV",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/channels/tablo.jpg?ch=width&auto=format,compress",
    },
    {
      name: "Sling",
      image:
        "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/icons/Sling.jpg?ch=width&auto=format,compress",
    },
  ]

  return (
    <StyledChannelsSection>
      <h2>Fubo Sports Network is Available On</h2>
      <div className="channels-section">
        <div className="channels-row">
          {list.slice(0, 6).map((item, index) => (
            <div className="image" key={index}>
              <img src={item.image} alt={item.name} />
            </div>
          ))}
        </div>
        <div className="channels-row">
          {list.slice(6).map((item, index) => (
            <div className="image" key={index}>
              <img src={item.image} alt={item.name} />
            </div>
          ))}
        </div>
      </div>
      <FuboBanner />
    </StyledChannelsSection>
  )
}

export default ChannelsSection

const StyledChannelsSection = styled(StyledSectionContainer)`
  padding-left: 20px;
  padding-right: 20px;
  @media (max-width: 767px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  h2 {
    text-align: center;
  }
  .channels-section {
    color: rgb(36, 36, 36);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
    .channels-row {
      display: flex;
      gap: 20px;
      justify-content: center;
      flex-wrap: nowrap;
    }
    .image {
      flex: 0 0 133px;
      border-radius: 11px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    @media (max-width: 1100px) {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      max-width: 600px;
      margin: 0 auto;
      .channels-row {
        display: contents;
      }
      .image {
        flex: 0 0 calc((100% - 60px) / 4);
      }
    }
    @media (max-width: 480px) {
      .image {
        flex: 0 0 calc((100% - 40px) / 3);
      }
    }
  }
`
